import l from "./ghl-ui.es1589.js";
import q from "./ghl-ui.es1590.js";
import s from "./ghl-ui.es1586.js";
import c from "./ghl-ui.es1587.js";
import p from "./ghl-ui.es1588.js";
import i from "./ghl-ui.es1591.js";
import { Parser as f } from "./ghl-ui.es1670.js";
import { parseNDigits as d } from "./ghl-ui.es1671.js";
var T = /* @__PURE__ */ function(u) {
  c(n, u);
  var o = p(n);
  function n() {
    var a;
    l(this, n);
    for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
      t[e] = arguments[e];
    return a = o.call.apply(o, [this].concat(t)), i(s(a), "priority", 120), i(s(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return q(n, [{
    key: "parse",
    value: function(r, t, e) {
      switch (t) {
        case "q":
        case "qq":
          return d(t.length, r);
        case "qo":
          return e.ordinalNumber(r, {
            unit: "quarter"
          });
        case "qqq":
          return e.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || e.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return e.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return e.quarter(r, {
            width: "wide",
            context: "standalone"
          }) || e.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || e.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, t) {
      return t >= 1 && t <= 4;
    }
  }, {
    key: "set",
    value: function(r, t, e) {
      return r.setUTCMonth((e - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(f);
export {
  T as StandAloneQuarterParser
};
